module.exports = __webpack_public_path__ + "0c50fe67b0af375e8487d45f8f49449c.svg";